export const LOCAL_STORAGE_TOKEN_KEY = 'access_token';
export const LOCAL_STORAGE_ID_TOKEN_KEY = 'id_token';

export const EMAIL_PATTERN =
  /^[_A-Za-z0-9]+(\.[_A-Za-z0-9]+)*@[A-Za-z0-9-]+(\.[A-Za-z0-9-]+)*(\.[A-Za-z]{2,4})$/;
export const LETTERS_PATTERN = /^[a-zA-Z ]+$/;
export const LETTERS_AND_NUMBERS_PATTERN = /^[a-zA-Z0-9]*$/;
export const LETTERS_NUMBERS_AND_STAR_PATTERN = /^[a-zA-Z0-9*]*$/;
export const LETTERS_NUMBERS_AND_DOT_PATTERN = /^[a-zA-Z0-9.]+$/;
export const LETTERS_AND_NUMBERS_MAX_15_PATTERN = /^[a-zA-Z0-9]{1,15}$/;
export const LETTERS_AND_NUMBERS_AND_DOT_MAX_15_PATTERN = /^[a-zA-Z0-9.]{1,15}$/;
export const LETTERS_AND_SIGNS_PATTERN = /^[a-zA-Z\s!@#$%^&*().,<>{}[\]<>?_=+\\-|-;:\`~'\"\/]*$/;
export const LETTERS_NUMBERS_AND_SIGNS_PATTERN =
  /^[a-zA-Z0-9\s!@#$%^&*().,<>{}[\]<>?_=+\\-|-;:\`~'\"\/]*$/;
export const LETTERS_SPACE_DASH_APOSTROPHESS = /^[a-zA-Z\s!\-'\"\`]*$/;
export const LETTERS_NUMBERS_DEFAULT_SYMBOLS = /^[a-zA-Z0-9\s!#$%&*()+.,:'\`\"\-]*$/; /// DEFAULT TEXT VALIDATION

export const LETTERS_WITH_SPACES_AND_SIGNS = /^[A-Za-z\s\-'’]*$/;
export const LETTERS_NUMBERS_WITH_SPACES_AND_HYPHEN = /^[A-Za-z0-9\s\-]*$/;
export const LETTERS_NUMBERS_WITH_COMMA_PERIOND_HYPHEN = /^[A-Za-z0-9\s,.\-]*$/;
export const LETTERS_NUMBERS_WITH_SPACE_COMMA_PERIOD_HYPHEN_QUOTES = /^[a-zA-Z0-9 ,.\-'"!:;?]*$/;

export const PHONE_PATTERN =
  /^((\+\d{1,3}(-| )?\(?\d\)?(-| )?\d{1,5})|(\(?\d{2,6}\)?))(-| )?(\d{3,4})(-| )?(\d{4})(( x| ext)\d{1,5}){0,1}$/;
export const NUMBERS_PATTERN = /^[0-9]*$/;
export const YEAR_PATTERN = /^\d{4}$/;
export const DECIMALS_PATTERN = /^\d*\.?\d*$/;
export const DECIMALS_PATTERN_2 = /^[0-9]+(\.[0-9]{1,2})?$/;
export const DECIMALS_PATTERN_5 = /^[0-9]+([.][0-9]{1,5})?$/;
export const DECIMALS_PATTERN_10 = /^[0-9]+(\.[0-9]{1,10})?$/;
export const IDENT_NUMBER_PATTERN = /^[0-9-]*$/;
export const NUMBER_PATTERN_9_DIGIDS = /^\d{9}$/; // digits only, lenght:5 / lenght:9

export const SERVER_DATE_FORMAT = 'YYYY-MM-DD';

export const LETTERS_NUMBERS_SPACE_AND_DASH = /^[a-zA-Z0-9-\s]+$/;
export const LETTERS_NUMBERS_AND_SPACES = /^[a-zA-Z0-9 ]+$/;
export const LETTERS_NUMBERS_HASHTAG_AND_DASH = /^[a-zA-Z0-9\s#-]+$/;
export const LETTERS_NUMBERS_HASHTAG_AMPERSAND_DASH_SPACE_AND_COMMA = /^[a-zA-Z0-9\s#,&-]+$/;
export const NUMBERS_BRACKETS_PLUS_DASH_AND_SPACES = /^[0-9\s)(+-]+$/;
export const LETTERS_NUMBERS_DOTS = /^[a-zA-Z0-9.]*$/;
export const NUMBERS_SPACE_DASH = /^[0-9\s-]*$/;
export const CURRENCY = /^(?:\s*|[+-]?((\d{0,16}(\.\d{1,2})?)))$/;
export const PERCENTAGE = /^100(\.0+)?$|^(\d{0,2}(\.\d+)?)$|^0\.\d+$|^0?\.00001$/;
export const EMAIL = /^$|^([\w\.\+-]+)@([\w\-]+)((\.(\w){1,15})+)$/;
export const AVALARA_EMAIL_REGEX = /([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})/g;

export const TEXT_EXTRACTOR = /\*\*(.*?)\*\*/g;
export const EMAIL_EXTRACTOR = /([a-zA-Z0-9!#$%&'*+/=?^_`{|}~.-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})/g;
export const LINK_EXTRACTOR = /##(.*?)##/g;

export const DEFAULT_INPUT_MAX_LENGTH = 151;
export const DEFAULT_TEXTAREA_MAX_LENGTH = 251;

export const MAX_FILE_SIZE = 12_582_912; // 12 * 1024 * 1024 = 12MB
